import { fork } from 'redux-saga/effects'

import { contractorPortalAuthSaga } from './contractorPortal/auth'
import { contractorPortalContractorSaga } from './contractorPortal/driver'
import { contractorPortalPartnersSaga } from './contractorPortal/partners'
import { contractorPortalInvoicesSaga } from './contractorPortal/invoices'
import { contractorPortalDocumentsSaga } from './contractorPortal/documents'
import { contractorPortalBankInformationSaga } from './contractorPortal/bankInformation'

import { partnerSaga } from './partner'
import { nhtsaSaga } from './nhtsa'
import { driverSaga } from './driver'
import { lmsTrainingSaga } from './lmsTraining'
import { contractorPortalStitchSaga } from './contractorPortal/stitch'
import { contractorPortalDriverDataSaga } from './contractorPortal/driverData'
import { contractorPortalDebitCardSaga } from './contractorPortal/debitCard'
import { fetchPaymentMethodSaga } from './paymentMethod'
import { authSaga } from './auth'

import { documentsSaga } from './documents'
import { personaSaga } from './persona'
import { yardstikSaga } from './yardstik'
import { docusignSaga } from './docusign'
import { stitchSaga } from './stitch'
import { optOutSaga } from './optOut'
import { ssnSaga } from './ssn'
import { mcNumberSaga } from './mcNumber'
import { dotNumberSaga } from './dotNumber'
import { usDOTNumberSaga } from './usDOTNumber'
import { debitCardSaga } from './debitCard'
import { bankInformationSaga } from './bankInformation'
import { skipStepSaga } from './skipStep'

export function* rootSaga() {
  yield fork(authSaga)
  yield fork(driverSaga)
  yield fork(documentsSaga)
  yield fork(personaSaga)
  yield fork(yardstikSaga)
  yield fork(docusignSaga)
  yield fork(stitchSaga)
  yield fork(optOutSaga)
  yield fork(mcNumberSaga)
  yield fork(dotNumberSaga)
  yield fork(usDOTNumberSaga)
  yield fork(debitCardSaga)
  yield fork(bankInformationSaga)
  yield fork(skipStepSaga)
  yield fork(ssnSaga)
  yield fork(partnerSaga)
  yield fork(contractorPortalAuthSaga)
  yield fork(contractorPortalContractorSaga)
  yield fork(contractorPortalPartnersSaga)
  yield fork(contractorPortalInvoicesSaga)
  yield fork(contractorPortalDocumentsSaga)
  yield fork(contractorPortalStitchSaga)
  yield fork(contractorPortalDriverDataSaga)
  yield fork(contractorPortalBankInformationSaga)
  yield fork(contractorPortalDebitCardSaga)
  yield fork(nhtsaSaga)
  yield fork(lmsTrainingSaga)
  yield fork(fetchPaymentMethodSaga)
}
